import React, {useCallback, useEffect} from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export function MessageAlert(props){
  let {type, message, id} = props
    
  let content = "";
  
  let toastSetting = useCallback( ()=>{
        return  {
          theme: "colored",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId:`gstart-message-${id}`
        }
  },[id])

  // const [alertCls, setAlertCls] = useState({
  //     'error':"danger",
  //     "success":"success",
  //     "message":"message",
  //     "warning":"warning"
  // })
  if(Array.isArray(message) && message.length > 0){
    message.forEach((item)=>{
      content = `${content} <br/> -${item}`
    })
  }else{
    content = message
  }
  useEffect(()=>{
    if(content && content.trim() !== ""){
      switch (type) {
      case "error":
        toast.error(content,toastSetting);
        break;
      case "success":
        toast.success(content,toastSetting);
        break;
      case "warning":
        toast.warning(content,toastSetting);
        break;
      default:
        break;
      }
    }
  },[content, message, toastSetting, type])

  return(
    <React.Fragment>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />{/* Same as */}
      {/* <div style={{fontSize: "12px", lineHeight: "20px"}} className={`alert alert-${alertCls[type]}`} role="alert">
            {content}
            </div> */}
    </React.Fragment>
  )

}